import { AsyncPipe, NgClass, NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TrackByFunction } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@woolworthsnz/styleguide';
import { FilterCriteria } from '@woolworthsnz/trader-api';
import { SearchQueryParams } from '../models/search-query-params.model';

@Component({
	selector: 'search-category-list',
	standalone: true,
	imports: [AsyncPipe, ButtonComponent, NgClass, NgFor, NgIf, RouterLink, TitleCasePipe],
	templateUrl: './search-category-list.component.html',
	styleUrls: ['./search-category-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCategoryListComponent {
	@Input() dasFacets: FilterCriteria[] = [];
	@Input() dasFacetsRoute: string[] = [];
	@Input() dasFacetsQueryParams: SearchQueryParams[] = [];

	currentIndex = -1;

	@Input() set currentShelf(value: FilterCriteria) {
		this.currentIndex = this.dasFacets.findIndex(
			(item) => !!value && item.key === value.key && item.name === value.name
		);
	}

	trackByFacet: TrackByFunction<FilterCriteria> = (_, facet) => facet.value;

	handleClickDasFacet = (event: Event, index: number): void => {
		event.preventDefault();
		this.currentIndex = index;
	};
}
